// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"305b7923","903":"7f79f622"}[chunkId] + ".chunk.js";
};